<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">User</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/users/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>

    </main>
</template>
<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/Users/MenuList.vue";
    import lang from "@/views/modules/Users/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomList from "@/views/modules/Users/ListView.vue";
    import CustomSearch from "@/views/modules/Users/SearchView.vue";
    export default {
        name: "new-users",
        components: {
            breadcrumbs,
            GenericList,
            CustomList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive: false,
                metaList: [
                    {
                        label: lang.LBL_FIRST_NAME,
                        link: true,
                        moduleName: 'Users',/// moduleName is required
                        routePath: 'users',/// routePath is required at start of object
                        isSort: true,
                        field_name: 'first_name'
                    },
                    {
                        label: lang.LBL_LAST_NAME,
                        link: true,
                        routePath: 'users',
                        isSort: true,
                        field_name: 'last_name'
                    },
                    {
                        label: lang.LBL_USER_EMAIL,
                        link: true,
                        routePath: 'users',
                        isSort: true,
                        field_name: 'email'
                    },
                    {
                        label: lang.LBL_ROLE,
                        link: false,
                        routePath: '',
                        isSort: true,
                        relRef:'users_user_roles',
                        field_name: 'name'
                    },
                    {
                        label: lang.LBL_USER_STATUS,
                        link: false,
                        routePath: '',
                        isSort: true,
                        field_name: 'status'
                    },
                ],
                columns: ['first_name', 'last_name', 'email', 'user_role_name', 'status'],

            }
        },
        mounted() {
            this.childMethod();
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                } else {
                    if (search != '') {
                        this.$refs.loadCustom.getProducts(search);
                    }
                }
            },

            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }

</script>